export var MANUAL_IMAGE_CROP_TAG_PREFIX = "manual_image_crop:";
/**
 * This tag is specifically for cropped product hero images,
 * 3/4 for apparel product thumbnails.
 * for square product thumbnails, we will use the normal prefix.
 */ export var MANUAL_IMAGE_CROP_APPAREL_TAG_PREFIX = "manual_image_crop_3x4:";
